import React, { useContext } from "react";
import "../scss/resume.scss";
import { useHistory } from "react-router-dom";
import { NewProjectContext } from "../context/NewProjectContext";
import { sendEmail } from "../utils/email";

const Option = ({ text, value }) => {
  return (
    <div className="item">
      <span>{text}:</span>
      <p>{value}</p>
    </div>
  );
};

const ProjectResume = () => {
  const { need, pack, order, updateStorage } = useContext(NewProjectContext);
  const history = useHistory();

  const handleValidation = (e) => {
    e.preventDefault();
    const params = {
      need: need,
      pack: pack.name,
      title: order.title,
      deliveryDate: order.deliveryDate,
      budget: order.budget,
      description: order.description,
      lastName: order.lastName,
      firstName: order.firstName,
      email: order.email,
      tel: order.tel,
    };

    sendEmail("order", params);
    updateStorage({need: "", pack: null, order: null});
    history.push("/");
  };

  return (
    <div className="resume">
      <h1>Résumé de la commande</h1>
      <div className="resume-details">
        <Option text="Catégorie" value={need} />
        <Option text="Formule choisie" value={pack.name} />
        <div className="order-details">
          <Option text="Titre" value={order.title} />
          <Option text="Date de livraison" value={order.deliveryDate} />
          <Option text="Budget" value={order.budget} />
          <Option text="Description" value={order.description} />
          <Option text="Nom" value={order.lastName} />
          <Option text="Prenom" value={order.firstName} />
          <Option text="Email" value={order.email} />
          <Option text="Téléphone" value={order.tel} />
        </div>
      </div>
      <div className="buttons">
        <button className="btn" onClick={(e) => handleValidation(e)}>
          Valider
        </button>
        <button className="btn" onClick={() => history.push("/newproject")}>
          Modifier
        </button>
      </div>
    </div>
  );
};

export default ProjectResume;
